export const NATIVE_TYPE = 0
export const BYOT_TYPE = 1
